<template>
  <div class="bill-template" :class="{ 'is-a5': isA5 }" :style="templateStyle">
    <!-- Header: Store Info -->
    <div class="header text-center mb-3">
      <div v-if="settings.showCompanyLogo" class="logo mb-1">
        <img v-if="system.logo" :src="system.logo" style="max-height: 50px;">
      </div>
      <div v-if="settings.showCompanyName" class="company-name">{{ system.storeName }}</div>
      <div v-if="settings.showCompanyAddress" class="company-detail">Địa chỉ: {{ system.address }}</div>
      <div v-if="settings.showCompanyPhone" class="company-detail">Điện thoại: {{ system.phone }}</div>
    </div>

    <!-- Bill Title -->
    <div class="text-center bill-title-section">
        <h5 class="bill-title">{{ order.isDraft ? 'PHIẾU TẠM TÍNH' : 'HÓA ĐƠN BÁN HÀNG' }}</h5>
        <p v-if="order.isDraft" class="draft-note">(Chưa có giá trị thanh toán)</p>
    </div>

    <!-- Order Info - Side by Side Layout -->
    <div class="info-section">
      <div v-if="settings.showOrderCode" class="info-row">
        <span class="info-left"><b>Số HĐ:</b> {{ order.id }}</span>
        <span v-if="settings.showOrderDate" class="info-right"><b>Thời gian:</b> {{ formatDate(order.createdAt) }}</span>
      </div>
      <div v-if="settings.showCustomerName" class="info-row">
        <span class="info-left"><b>Khách hàng:</b> {{ order.customer?.name || 'Khách lẻ' }}</span>
        <span v-if="settings.showCustomerPhone && order.customer?.phone" class="info-right"><b>SĐT:</b> {{ order.customer.phone }}</span>
      </div>
      <div v-if="isA5 && order.customer?.address" class="info-row">
        <span class="info-left"><b>Địa chỉ:</b> {{ order.customer.address }}</span>
      </div>
      <div v-if="settings.showCashierName" class="info-row">
        <span class="info-left"><b>Thu ngân:</b> {{ order.user?.name || 'Admin' }}</span>
      </div>
    </div>

    <!-- Product Table with Full Borders -->
    <table class="product-table">
      <thead>
        <tr>
          <th class="col-tt text-center">TT</th>
          <th class="col-name text-left">TÊN HÀNG</th>
          <th v-if="settings.showUnit" class="col-unit text-center">ĐVT</th>
          <th v-if="settings.showQuantity" class="col-qty text-center">SỐ LƯỢNG</th>
          <th v-if="settings.showPrice" class="col-price text-right">ĐƠN GIÁ</th>
          <th v-if="settings.showSubtotal" class="col-total text-right">THÀNH TIỀN</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(item, index) in order.cart" :key="index">
          <td class="text-center">{{ index + 1 }}</td>
          <td class="text-left">
            {{ item.product?.name }}
            <span v-if="item.product?.code && settings.showProductCode" class="product-code">({{ item.product.code }})</span>
          </td>
          <td v-if="settings.showUnit" class="text-center">{{ item.product?.unit }}</td>
          <td v-if="settings.showQuantity" class="text-center">{{ Number(item.quantity).toLocaleString() }}</td>
          <td v-if="settings.showPrice" class="text-right">{{ Number(item.price).toLocaleString() }}</td>
          <td v-if="settings.showSubtotal" class="text-right">{{ Number(item.price * item.quantity).toLocaleString() }}</td>
        </tr>
        <!-- Summary Rows inside table -->
        <tr v-if="settings.showTotalAmount" class="summary-row">
          <td :colspan="summaryColspan" class="text-center summary-label">Tổng cộng</td>
          <td v-if="settings.showQuantity" class="text-center">{{ totalQuantity.toLocaleString() }}</td>
          <td v-if="settings.showPrice" class="text-right"></td>
          <td v-if="settings.showSubtotal" class="text-right summary-value">{{ Number(order.totalBill).toLocaleString() }}</td>
        </tr>
        <tr v-if="settings.showPaidAmount" class="summary-row">
          <td :colspan="summaryValueColspan" class="text-center summary-label">Khách thanh toán</td>
          <td v-if="settings.showSubtotal" class="text-right summary-value">{{ Number(order.paid).toLocaleString() }}</td>
        </tr>
        <tr v-if="customerDeposit > 0" class="summary-row">
          <td :colspan="summaryValueColspan" class="text-center summary-label">Tiền cọc cũ</td>
          <td v-if="settings.showSubtotal" class="text-right summary-value">{{ Number(customerDeposit).toLocaleString() }}</td>
        </tr>
        <tr v-if="newDeposit > 0" class="summary-row">
          <td :colspan="summaryValueColspan" class="text-center summary-label">Tiền cọc mới</td>
          <td v-if="settings.showSubtotal" class="text-right summary-value">{{ Number(newDeposit).toLocaleString() }}</td>
        </tr>
        <tr v-if="settings.showDebtAmount" class="summary-row">
          <td :colspan="summaryValueColspan" class="text-center summary-label">Nợ cũ</td>
          <td v-if="settings.showSubtotal" class="text-right summary-value">{{ Number(oldDebt).toLocaleString() }}</td>
        </tr>
        <tr v-if="settings.showCustomerDebt" class="summary-row">
          <td :colspan="summaryValueColspan" class="text-center summary-label">Tổng Nợ</td>
          <td v-if="settings.showSubtotal" class="text-right summary-value">{{ Number(totalDebt).toLocaleString() }}</td>
        </tr>
      </tbody>
    </table>



    <!-- Note -->
    <div v-if="settings.showOrderNote && order.note" class="note-section">
      <b>Ghi chú:</b> {{ order.note }}
    </div>

    <!-- Signature Area -->
    <div class="signature-section">
      <div class="sig-left">
        <div class="sig-title">KHÁCH HÀNG</div>
        <div class="sig-space"></div>
      </div>
      <div class="sig-right">
        <div class="sig-title">NGƯỜI LẬP PHIẾU</div>
        <div class="sig-space"></div>
      </div>
    </div>

    <!-- Footer -->
    <div class="footer-section text-center">
      <div v-if="settings.showFooterNote && settings.footerNote" class="footer-note">
        <i>{{ settings.footerNote }}</i>
      </div>
      <div v-else class="footer-note">
        <i>Cảm ơn và hẹn gặp lại quý khách!</i>
      </div>
    </div>

    <div class="text-center software-credit">
        Phần mềm bán hàng - cuongdev.pro.vn
    </div>
  </div>
</template>

<script>
export default {
  name: 'BillTemplate',
  props: {
    order: {
      type: Object,
      required: true
    },
    settings: {
      type: Object,
      required: true
    },
    system: {
      type: Object,
      default: () => ({
          storeName: 'Cửa hàng Lô Gạch',
          address: 'Chưa cập nhật',
          phone: '',
          logo: ''
      })
    }
  },
  computed: {
    isA5() {
      return this.settings.paperSize === 'A5';
    },
    templateStyle() {
      if (this.isA5) return { width: '100%', padding: '0', margin: '0', backgroundColor: 'white', boxSizing: 'border-box' };
      const size = this.settings.paperSize === '58mm' ? '58mm' : '80mm';
      return { width: '100%', maxWidth: size, backgroundColor: 'white', boxSizing: 'border-box' };
    },
    totalQuantity() {
      return (this.order.cart || []).reduce((sum, item) => sum + Number(item.quantity || 0), 0);
    },
    rawOldDebt() {
      if (this.order.isDraft) {
          // In a draft, customer.debtAmount represents the debt BEFORE this transaction.
          const draftDebt = this.order.customer ? Number(this.order.customer.debtAmount) : 0;
          return isNaN(draftDebt) ? 0 : draftDebt;
      }
      const finalDebt = this.order.finalTotalDebt !== undefined ? this.order.finalTotalDebt : (this.order.customer?.debtAmount || 0);
      let debtDelta = Number(this.order.totalBill || 0) - Number(this.order.paid || 0);
      
      if (debtDelta < 0 && !this.order.convertToDeposit) {
           debtDelta = 0; 
      }
      return Number(finalDebt) - debtDelta;
    },
    finalTotalDebtComputed() {
      if (this.order.isDraft) {
          // Simulate the debt AFTER this transaction
          const oldDebt = this.rawOldDebt;
          let debtDelta = Number(this.order.totalBill || 0) - Number(this.order.paid || 0);
          
          if (debtDelta < 0 && !this.order.convertToDeposit) {
               // If overpaid but NOT converting to deposit, the excess does not reduce debt.
               debtDelta = 0; 
          }
          return oldDebt + debtDelta;
      }
      return this.order.finalTotalDebt !== undefined ? this.order.finalTotalDebt : (this.order.customer?.debtAmount || 0);
    },
    customerDeposit() {
      // If rawOldDebt is negative, the customer has a deposit (store owes customer)
      return this.rawOldDebt < 0 ? Math.abs(this.rawOldDebt) : 0;
    },
    oldDebt() {
      // Old debt should not be negative — negative means deposit, shown separately
      return Math.max(0, this.rawOldDebt);
    },
    totalDebt() {
      // If total debt is negative (customer has credit), show 0
      return Math.max(0, Number(this.finalTotalDebtComputed));
    },
    newDeposit() {
      // If final debt is negative, customer still has deposit remaining
      return Number(this.finalTotalDebtComputed) < 0 ? Math.abs(Number(this.finalTotalDebtComputed)) : 0;
    },
    // Calculate colspan for "Tổng cộng" row (TT + TÊN HÀNG + ĐVT)
    summaryColspan() {
      let cols = 2; // TT + TÊN HÀNG always present
      if (this.settings.showUnit) cols++;
      return cols;
    },
    // Calculate colspan for summary value rows (all columns except last)
    summaryValueColspan() {
      let cols = 2; // TT + TÊN HÀNG
      if (this.settings.showUnit) cols++;
      if (this.settings.showQuantity) cols++;
      if (this.settings.showPrice) cols++;
      return cols;
    }
  },
  methods: {
    formatDate(date) {
      return new Date(date).toLocaleString('vi-VN');
    },
    numberToVietnameseWords(num) {
      num = Math.abs(Math.round(Number(num) || 0));
      if (num === 0) return 'không';

      const ones = ['', 'một', 'hai', 'ba', 'bốn', 'năm', 'sáu', 'bảy', 'tám', 'chín'];
      const units = ['', 'nghìn', 'triệu', 'tỷ', 'nghìn tỷ', 'triệu tỷ'];

      const readGroup = (n) => {
        const h = Math.floor(n / 100);
        const t = Math.floor((n % 100) / 10);
        const u = n % 10;
        let result = '';

        if (h > 0) {
          result += ones[h] + ' trăm';
          if (t === 0 && u > 0) result += ' lẻ';
        }
        if (t > 1) {
          result += ' ' + ones[t] + ' mươi';
          if (u === 1) result += ' mốt';
          else if (u === 5) result += ' lăm';
          else if (u > 0) result += ' ' + ones[u];
        } else if (t === 1) {
          result += ' mười';
          if (u === 5) result += ' lăm';
          else if (u > 0) result += ' ' + ones[u];
        } else if (u > 0) {
          result += ' ' + ones[u];
        }

        return result.trim();
      };

      const groups = [];
      while (num > 0) {
        groups.push(num % 1000);
        num = Math.floor(num / 1000);
      }

      let result = '';
      for (let i = groups.length - 1; i >= 0; i--) {
        if (groups[i] > 0) {
          result += readGroup(groups[i]) + ' ' + units[i] + ' ';
        }
      }

      result = result.trim();
      // Capitalize first letter
      return result.charAt(0).toUpperCase() + result.slice(1);
    }
  }
};
</script>

<style scoped>
.bill-template {
    font-family: 'Times New Roman', Times, serif;
    margin: 0 auto;
    font-size: 28px;
    line-height: 1.4;
    color: #000 !important;
    padding: 5mm;
    overflow-wrap: break-word !important;
    word-wrap: break-word !important;
}

/* ===== Header ===== */
.header {
    margin-bottom: 15px;
}
.company-name {
    font-size: 42px;
    font-weight: bold !important;
    text-transform: uppercase;
    line-height: 1.2;
    margin-bottom: 4px;
}
.company-detail {
    font-size: 36px;
    font-style: italic;
}

/* ===== Bill Title ===== */
.bill-title-section {
    margin: 25px 0 20px 0;
}
.bill-title {
    font-size: 36px !important;
    font-weight: bold !important;
    letter-spacing: 3px;
    margin: 0;
}
.draft-note {
    font-style: italic;
    font-size: 22px;
    margin: 4px 0 0 0;
}

/* ===== Info Section ===== */
.info-section {
    margin-bottom: 18px;
}
.info-row {
    display: flex;
    justify-content: space-between;
    margin-bottom: 5px;
    font-size: 28px;
}
.info-left {
    flex: 1;
    text-align: left;
}
.info-right {
    flex-shrink: 0;
    text-align: right;
    margin-left: 20px;
}

/* ===== Product Table ===== */
.product-table {
    width: 100%;
    border-collapse: collapse;
    margin-bottom: 15px;
    font-size: 28px;
}
.product-table th,
.product-table td {
    border: 1px solid #000 !important;
    padding: 8px 10px;
    color: #000 !important;
}
.product-table th {
    font-weight: bold !important;
    font-size: 26px;
    text-transform: uppercase;
    background-color: transparent;
}
.col-tt { width: 6%; }
.col-name { width: 30%; }
.col-unit { width: 10%; }
.col-qty { width: 14%; }
.col-price { width: 18%; }
.col-total { width: 22%; }

.product-code {
    font-size: 20px;
    color: #555 !important;
}

/* Summary rows inside table */
.summary-row td {
    border: 1px solid #000 !important;
    font-weight: bold !important;
}
.summary-label {
    font-weight: bold !important;
}
.summary-value {
    font-weight: bold !important;
}
.label-sub-payment, .value-sub-payment {
    font-weight: normal !important;
    font-size: 0.9em;
}

/* ===== Amount in Words ===== */
.amount-words-section {
    margin: 15px 0;
    font-size: 26px;
}
.amount-words {
    margin-bottom: 4px;
}

/* ===== Note ===== */
.note-section {
    margin: 12px 0;
    font-size: 26px;
}

/* ===== Signature Area ===== */
.signature-section {
    display: flex;
    justify-content: space-between;
    margin: 35px 0 15px 0;
    text-align: center;
}
.sig-left, .sig-right {
    width: 45%;
}
.sig-title {
    font-weight: bold !important;
    font-size: 28px;
    text-transform: uppercase;
}
.sig-space {
    height: 80px;
}

/* ===== Footer ===== */
.footer-section {
    margin-top: 10px;
    font-size: 26px;
}
.footer-note {
    font-style: italic;
}
.software-credit {
    font-size: 22px;
    margin-top: 12px;
    color: #666 !important;
}

/* ===== Ensure all text is black for printing ===== */
.bill-template span, .bill-template div, .bill-template td, .bill-template th, .bill-template p {
    color: #000 !important;
}

/* ===== A5 Specific Overrides ===== */
.is-a5 {
    font-family: 'Times New Roman', Times, serif;
    font-size: 30px;
}
.is-a5 .company-name {
    font-size: 50px;
}
.is-a5 .bill-title {
    font-size: 44px !important;
}
.is-a5 .product-table {
    font-size: 30px;
}
.is-a5 .product-table th,
.is-a5 .product-table td {
    padding: 10px 12px;
}
.is-a5 .info-row {
    font-size: 30px;
}
.is-a5 .sig-space {
    height: 100px;
}
.is-a5 .amount-words-section {
    font-size: 28px;
}
.is-a5 .note-section {
    font-size: 28px;
}
.is-a5 .footer-section {
    font-size: 28px;
}

/* ===== 80mm / 58mm thermal override ===== */
.bill-template:not(.is-a5) {
    font-size: 13px;
}
.bill-template:not(.is-a5) .company-name {
    font-size: 18px;
}
.bill-template:not(.is-a5) .bill-title {
    font-size: 16px !important;
}
.bill-template:not(.is-a5) .product-table {
    font-size: 12px;
}
.bill-template:not(.is-a5) .product-table th,
.bill-template:not(.is-a5) .product-table td {
    padding: 3px 4px;
}
.bill-template:not(.is-a5) .sig-space {
    height: 40px;
}
.bill-template:not(.is-a5) .signature-section {
    margin: 10px 0 5px 0;
}
</style>
